/* global $ */
import setEqualHeight from './setEqualHeight'

function equaliseRows() {
    $('.row').each(function() {
        setEqualHeight($(this).find('.bordered_block:not(".col-md-12")'));
        setEqualHeight($(this).find('.block'));
    });
}

export default equaliseRows;



// WEBPACK FOOTER //
// ./src/modules/plugins/equaliseRows.js